import React from "react";
import { useHistory } from "react-router-dom";

import useWaitApiCall from "../../../hooks/useWaitApiCall";
import {
  Context,
  notFoundPath,
  fetchAvgAssessment,
  fetchAllDistributionsAssessment,
  updateAssessmentLastActive,
} from "../../../teacherStore";
import { fetchIDFromPath } from "../../../libs/Util";
import AllAssessmentDistribution from "../../../templates/teacher/AllAssessmentDistribution";
import useUpdateAssessmentLastActive from "../../../hooks/useUpdateAssessmentLastActive";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  const class_id = fetchIDFromPath();
  const [calling, peep] = useWaitApiCall(state);

  const currentClass = React.useMemo(
    () =>
      (state.teacher.classes.length &&
        state.teacher.classes.find(cls => cls.id === Number(class_id))) || {
        id: 0,
        name: "",
        grade: 0,
        charged: false,
        is_sub: false,
        full_name: "",
        assumed_entrance_year: 0,
      },
    [class_id, state.teacher.classes],
  );

  React.useEffect(() => {
    const { classes } = state.teacher;
    const classIDs = classes.map(cls => cls.id);
    if (classIDs.length && !classIDs.includes(Number(class_id))) {
      history.push(notFoundPath);
    }
  }, [class_id, history, state.teacher]);

  useUpdateAssessmentLastActive(
    state.teacher.assessment_last_active_date ?? null,
    dispatch,
    updateAssessmentLastActive,
  );

  React.useEffect(() => {
    dispatch(peep(fetchAllDistributionsAssessment(Number(class_id))));
    dispatch(peep(fetchAvgAssessment(Number(class_id))));
  }, [class_id, dispatch, peep]);

  return (
    <AllAssessmentDistribution
      loading={calling}
      currentClass={currentClass}
      allDistributions={state.allDistributions}
    />
  );
};
